import { useAuth0 } from '@auth0/auth0-react';
import { Layout } from 'antd';
import imgLogo from 'assets/img/logo.svg';
import styles from './AppHeader.module.less';
import HeaderNav from './HeaderNav';
import AvatarDropDowm from './AvatarDropDowm';
import { useHistory } from 'react-router-dom';

const { Header } = Layout;

export default function AppHeader() {
	const { user } = useAuth0();
	const history = useHistory();

	if (!user) return null;

	return (
		<Header className={styles.header}>
			<div
				className={styles.headerLogo}
				onClick={() => history.push('/projects')}
			>
				<img src={imgLogo} alt="logo" />
			</div>
			<HeaderNav />
			<div className={styles.headerAccount}>
				<AvatarDropDowm user={user} />
			</div>
		</Header>
	);
}
